'use client';

import { Bot } from 'lucide-react';
import { useEffect, useState } from 'react';

const messages = [
  "Hey there! 👋",
  "Need any help? 🤔",
  "I know all about Marcos! 🧠",
  "Got questions? I've got answers! 💡",
  "Pst... wanna hear a secret? 🤫",
  "I'm smarter than ChatGPT! (just kidding) 😅",
  "I promise I'm not Skynet! 🤖",
  "Let's chat! I don't byte! 💻",
  "404: Small talk not found 😄",
  "My humor module needs an upgrade... 🔧",
  "I run on coffee.js ☕",
  "Chat with me! I'm a good listener 👂",
];

export function RobotWidget() {
  const [isVisible, setIsVisible] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const [currentMessage, setCurrentMessage] = useState(0);
  const [isMessageVisible, setIsMessageVisible] = useState(true);

  useEffect(() => {
    // Show widget after a short delay
    const timer = setTimeout(() => setIsVisible(true), 1000);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (!isVisible) return;

    // Change message every 4 seconds
    const messageInterval = setInterval(() => {
      setIsMessageVisible(false);
      setTimeout(() => {
        setCurrentMessage((prev) => (prev + 1) % messages.length);
        setIsMessageVisible(true);
      }, 300); // Wait for fade out before changing message
    }, 10000);

    return () => clearInterval(messageInterval);
  }, [isVisible]);

  const scrollToChat = () => {
    const element = document.getElementById('chat');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  if (!isVisible) return null;

  return (
    <button
      onClick={scrollToChat}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      className="fixed bottom-8 right-8 p-4 bg-primary text-primary-foreground 
                 rounded-full shadow-lg cursor-pointer
                 transition-all duration-500 ease-in-out
                 hover:scale-110 hover:shadow-primary/30 hover:shadow-xl
                 animate-bounce-gentle
                 focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2
                 group z-50"
      aria-label="Chat with AI Assistant"
    >
      <Bot className={`w-6 h-6 transition-all duration-500 ${
        isHovered ? 'animate-wave' : ''
      }`} />
      <div 
        className={`absolute -top-14 right-0 whitespace-nowrap
                    px-4 py-2 rounded-lg bg-primary-foreground text-primary
                    text-sm font-medium shadow-lg
                    transition-all duration-300 origin-bottom-right
                    ${(isHovered || isMessageVisible) ? 'opacity-100 scale-100' : 'opacity-0 scale-95 translate-y-1'}
                    pointer-events-none
                    after:content-[''] after:absolute after:bottom-0 after:right-6
                    after:w-3 after:h-3 after:bg-primary-foreground after:rotate-45
                    after:translate-y-1/2`}
        aria-hidden="true"
      >
        {messages[currentMessage]}
      </div>
    </button>
  );
}